export const getItem = (key: string) => {
  if (typeof window === "undefined") return null;
  try {
    return sessionStorage.getItem(key);
  } catch {
    return null;
  }
};

export const setItem = (key: string, value: string) => {
  if (typeof window === "undefined") return;
  sessionStorage.setItem(key, value);
};

export const removeItem = (key: string) => {
  if (typeof window === "undefined") return;
  sessionStorage.removeItem(key);
};
